
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about_us/our_team",
      function () {
        return require("private-next-pages/about_us/our_team.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about_us/our_team"])
      });
    }
  